// User API Routes
export const USER_ME = "/user/me";
export const USER_SEND_OTP = "/user/send-otp";
export const USER_VERIFY_OTP = "/user/verify-otp";
export const USER_COMPLETE_REGISTRATION = "/user/complete-registration";
export const USER_MARKETING_CONSENT = "/user/marketing-consent";

// Games API Routes
export const ALL_GAMES = "/games/get-all";
export const CREATE_GAME = "/games/create";
export const CREATE_PRODUCT = (gameId) => `/games/${gameId}/diamond-pack`;
export const ALL_PRODUCTS = (gameId) => `/games/${gameId}/diamond-packs`;
export const PORDUCT_BY_ID = (productId) => `/games/dimond-pack/${productId}`;

// Order API Routes
export const CREATE_ORDER = "/order/diamond-pack";

// Wallet API Routes
export const WALLET_ADD = "/wallet/add";
export const WALLET_BALANCE = "/wallet/balance";
export const PAYMENT_STATUS = "/transaction/ekqr/status";
export const WALLET_HISTORY = "/wallet/history";

// Public Banners
export const PUBLIC_BANNERS = "/banners/public/banners";

// Leaderboard API Routes
export const USER_LEADERBOARD = "/user/leaderboard";
